export interface IAboutPageProps {}

const AboutPage: React.FunctionComponent<IAboutPageProps> = (props) => {
  return <p>This is the about page.</p>;
};

export { AboutPage };
